import { render, staticRenderFns } from "./crud.vue?vue&type=template&id=811d6f86"
import script from "./crud.vue?vue&type=script&lang=js"
export * from "./crud.vue?vue&type=script&lang=js"
import style0 from "./crud.vue?vue&type=style&index=0&id=811d6f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports